import React, { Component } from 'react'
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';

import MobileSettingsForm from '../../../components/SiteAdmin/MobileSettingsForm/MobileSettingsForm';
import Loader from '../../../components/Common/Loader/Loader';

import getSiteSettings from './getSiteSettings.graphql'
import messages from '../../../locale/messages';
import s from './MobileSettings.css';
export class MobileSettings extends Component {

  render() {
    const { formatMessage } = this.props.intl;
    const { getSiteSettings: { loading, getSiteSettings, refetch } } = this.props;
    let mobileSettingsCollection = {}

    if (!loading) {
      getSiteSettings?.map((item) => {
        mobileSettingsCollection[item.name] = item?.value
      });
    }

    return (
      <Loader type={"page"} show={loading} >
        <div className={s.root}>
          <div className={s.container}>
            {!loading && mobileSettingsCollection &&
              <>
                <div className={s.heading}>
                  {formatMessage(messages.mobileSettings)}
                </div>
                <div className={s.paddingRoutesSection}>
                  <MobileSettingsForm refetch={refetch} getSiteSettings={getSiteSettings} initialValues={mobileSettingsCollection} />
                </div>
              </>
            }
          </div>
        </div>
      </Loader>
    )
  }

}

export default compose(injectIntl,
  withStyles(s),
  graphql(getSiteSettings, {
    name: 'getSiteSettings',
    options: (props) => ({
      variables: {
        type: 'appSettings'
      },
      ssr: true,
    }),
  })
)(MobileSettings)
